exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resort-image[data-v-7560e6c5]{min-height:190px}.review-text[data-v-7560e6c5]{position:relative;line-height:3px}.discount-tag[data-v-7560e6c5]{font-size:12px;padding:3px 6px;width:fit-content}", ""]);

// exports
